import Http from '_u/request'
import { Toast } from 'vant'
import { lblApiConfig, sevApiConfig } from '@/config'
import store from '@/store'

const http = new Http()
const queue = {}

const Request = async ({ data = {}, ...config }) => {
  const scids = {
    1: 13, //App对应cid
    2: 7, //服务号对应cid
    3: 9, //小程序对应cid
    4: 20 //商城H5对应cid
  }
  config.headers = Object.assign(config.headers || {}, sevApiConfig, {
    scid: scids[store.state.sev.souce || 0]
  })
  let { apiLoading, apiReject, ...parameters } = data
  // 请求等待
  if (apiLoading) {
    queue[config.url] = Toast({
      message: typeof apiLoading === 'string' ? apiLoading : '加载中',
      forbidClick: true,
      duration: 0,
      className: 'sev-loading',
      icon: 'circle'
    })
  }
  let res = null
  try {
    // 第三方请求处理
    if (config.gate === 'lbl')
      parameters = {
        ...lblApiConfig,
        params: parameters
      }
    res = await http.request({ ...config, parameters })
    // 第三方请求处理
    if (config.gate === 'lbl') {
      res.code = res.result === 1 ? 0 : res.result
      res.data = res.params
      delete res.result
      delete res.params
      delete res.seq
      delete res.waitNum
      delete res.waitTime
    }
  } catch (err) {
    const errObj = {
      'Network Error': '网络不佳',
      'Request failed with status code 404': '服务器开小差了'
    }
    err.message = errObj[err.message] || err.message
    if (/timeout of/.test(err.message)) err.message = '服务器繁忙'
    res = err
  } finally {
    // 请求等待结束
    if (queue[config.url]) {
      queue[config.url].clear()
      delete queue[config.url]
    }
  }
  // 请求错误反馈
  if ((!apiReject || (typeof apiReject === 'number' && res.code !== apiReject)) && res.code !== 0) {
    Toast({
      message: res.message || res.msg,
      forbidClick: true,
      icon: require('img/crm/icon/close.png')
    })
  }
  if (res.code === 0) console.log(`${config.title}成功`, res)
  else console.error(`${config.title}失败`, res, parameters)
  return res
}

export default Request
